import { useEffect } from "react";
import { SITE_URL, TRACKING_PATH_PREFIX } from "../components/Siteconfig";
import { applyPageSeo } from "../utils/seo";
export default function useBlogSEO(post) {
  useEffect(() => {
    if (!post) return;
    const title = `${post.seoTitle || post.title} — What Next Blog`;
    const description = post.seoDescription || post.excerpt || "";
    const canonicalUrl = post.canonicalUrl || `${SITE_URL}/blog/${post.slug}`;
    const image = post.images?.[0] || post.coverImage || "";
    const trackingPath = `${TRACKING_PATH_PREFIX}/blog/${post.slug}`;
    applyPageSeo({ title, description, canonicalUrl, image });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "page_view",
      page_path: trackingPath,
      page_title: title,
      blog_slug: post.slug,
    });
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: trackingPath,
        page_title: title,
      });
    }
  }, [post]);
}